import { render, staticRenderFns } from "./UnpaidInvoicesCard.vue?vue&type=template&id=70f13da0&"
import script from "./UnpaidInvoicesCard.vue?vue&type=script&lang=js&"
export * from "./UnpaidInvoicesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UnpaidInvoicesCard.vue"
export default component.exports